var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "magic-wand") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-4",
    transform: "translate(-664.000000, -379.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 134,
    transform: "translate(664.000000, 379.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-83",
    stroke: "currentColor",
    strokeWidth: 2,
    transform: "translate(9.981477, 14.003305) rotate(-315.000000) translate(-9.981477, -14.003305) ",
    x: 7.98147698,
    y: 2.70503199,
    width: 4,
    height: 22.5965469,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,9 L15,12",
    id: "Path-62",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,0.497698784 C22,0.21484375 21.7761424,0 21.5,0 C21.2319336,0 21,0.222827336 21,0.497698784 L21,1.00630944 C21,1.55510958 20.5573855,2 20.0063094,2 L19.4976988,2 C19.2148438,2 19,2.22385763 19,2.5 C19,2.76806641 19.2228273,3 19.4976988,3 L20.0063094,3 C20.5551096,3 21,3.44261449 21,3.99369056 L21,4.50230122 C21,4.78515625 21.2238576,5 21.5,5 C21.7680664,5 22,4.77717266 22,4.50230122 L22,3.99369056 C22,3.44489042 22.4426145,3 22.9936906,3 L23.5023012,3 C23.7851562,3 24,2.77614237 24,2.5 C24,2.23193359 23.7771727,2 23.5023012,2 L22.9936906,2 C22.4448904,2 22,1.55738551 22,1.00630944 L22,0.497698784 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-71",
    fill: "currentColor",
    cx: 23,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-71",
    stroke: "currentColor",
    cx: 12.5,
    cy: 1.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,12.495389 C21,12.2157526 20.7761424,12 20.5,12 C20.2319336,12 20,12.2217932 20,12.495389 L20,12.501056 C20,12.7766152 19.7713173,13 19.501056,13 L19.495389,13 C19.2157526,13 19,13.2238576 19,13.5 C19,13.7680664 19.2217932,14 19.495389,14 L19.501056,14 C19.7766152,14 20,14.2286827 20,14.498944 L20,14.504611 C20,14.7842474 20.2238576,15 20.5,15 C20.7680664,15 21,14.7782068 21,14.504611 L21,14.498944 C21,14.2233848 21.2286827,14 21.498944,14 L21.504611,14 C21.7842474,14 22,13.7761424 22,13.5 C22,13.2319336 21.7782068,13 21.504611,13 L21.498944,13 C21.2233848,13 21,12.7713173 21,12.501056 L21,12.495389 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,4.49538898 C8,4.2157526 7.77614237,4 7.5,4 C7.23193359,4 7,4.2217932 7,4.49538898 L7,4.501056 C7,4.77661516 6.77131733,5 6.501056,5 L6.49538898,5 C6.2157526,5 6,5.22385763 6,5.5 C6,5.76806641 6.2217932,6 6.49538898,6 L6.501056,6 C6.77661516,6 7,6.22868267 7,6.498944 L7,6.50461102 C7,6.7842474 7.22385763,7 7.5,7 C7.76806641,7 8,6.7782068 8,6.50461102 L8,6.498944 C8,6.22338484 8.22868267,6 8.498944,6 L8.50461102,6 C8.7842474,6 9,5.77614237 9,5.5 C9,5.23193359 8.7782068,5 8.50461102,5 L8.498944,5 C8.22338484,5 8,4.77131733 8,4.501056 L8,4.49538898 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.bf5f27de46d81257e939d720224de66b.svg";
export { ForwardRef as ReactComponent };